import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ChevronRight, Layers } from "lucide-react";

export default function BatchUploadLink() {
  const [params] = useSearchParams();
  const batch = params.get("batch");
  const [waiting, setWaiting] = useState(0);
  useEffect(() => {
    api.get("/photo-batches").then((r) => setWaiting(r.data.batches.filter((b) => b.stale).reduce((a, b) => a + b.to_list, 0))).catch(() => {});
  }, []);
  if (batch) {
    return (
      <div className="mx-auto max-w-5xl px-3 pt-3 sm:px-6">
        <Link to={`/batch?b=${batch}`} data-testid="back-to-batch" className="inline-flex items-center gap-1 text-xs font-semibold text-[#0053DA]">
          ← Back to batch
        </Link>
      </div>
    );
  }
  if (params.get("edit")) return null;
  return (
    <div className="mx-auto max-w-5xl px-3 pt-3 sm:px-6">
      <Link to="/batch" data-testid="open-batch-upload"
        className="flex items-center gap-2.5 rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-left shadow-sm transition-colors hover:bg-slate-50">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#0053DA]/10 text-[#0053DA]"><Layers className="h-4 w-4" /></span>
        <span className="min-w-0 flex-1">
          <span className="block text-sm font-semibold text-slate-900">Batch upload</span>
          {waiting ? <span className="block text-[11px] font-semibold text-amber-700" data-testid="batch-link-stale">{waiting} batch item{waiting === 1 ? "" : "s"} waiting over a week to be listed</span>
            : <span className="block text-[11px] text-slate-500">Photograph many items now, AI drafts them all, list them later one by one</span>}
        </span>
        <ChevronRight className="h-4 w-4 shrink-0 text-slate-400" />
      </Link>
    </div>
  );
}
